var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMolkky = function SvgMolkky(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M90.828 15.165c.302-1.254.213-2.34-.322-3.195-2.824-4.53-16.96-.982-31.582 7.924-13.489 8.22-22.665 18.124-21.788 23.164L37 110.01v.031C37.054 114.44 48.573 118 62.78 118c14.206 0 25.72-3.56 25.779-7.959h.031l2.234-94.88z"
  })));
};
export default SvgMolkky;